<template>
  <div class="over-screen" :class="{'active-loading': active }">
    <div class="loading-card">
      <div class="flex-center">
        <svg
          version="1.1"
          id="loader-1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="40px"
          height="40px"
          viewBox="0 0 40 40"
          enable-background="new 0 0 40 40"
          xml:space="preserve"
        >
          <path
            opacity="0.2"
            fill="#000"
            d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
      s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
      c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
          />
          <path
            fill="#000"
            d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
      C22.32,8.481,24.301,9.057,26.013,10.047z"
          >
            <animateTransform
              attributeType="xml"
              attributeName="transform"
              type="rotate"
              from="0 20 20"
              to="360 20 20"
              dur="0.5s"
              repeatCount="indefinite"
            />
          </path>
        </svg>
        <div class="pl-10">
          {{ wording || 'Preparing data, please wait...' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "downloadProgress",
  props: {
    wording: String,
    active: Boolean
  }
};
</script>

<style lang="scss" scoped>
svg > path {
  fill: #fff;
}
.over-screen {
  transition: .5s;
  position: fixed;
  width: auto;
  z-index: 999;
  left: 50%;
  transform: translateX(-50%);
  bottom: -100px;
  opacity: 0;
}
.active-loading {
  opacity: .9;
  bottom: 8px;
}
.loading-card {
  padding: 8px 24px 8px 16px;
  border-radius: 3px;
  box-shadow: 3px 3px 10px 3px #8b8b8b15;
  background-color: #323232;
  color: #fff;
}
</style>